/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchInput from "../../component/common/Input/SearchInput";
import shoorahLogo from "../../assets/images/shoorah-logo.jpg";
import { Api } from "../../api";
import { getPathForSurvey } from "../../utils/helper";
import Topbar from "../../container/PulseSurvey/Topbar";
import { errorToast } from "../../utils/helper";
import { isSubAdmin } from "../../utils/helper";
import AddSurveyPopup from "../../component/common/modals/CreatePopup";
import Pagination from "../../component/common/Pagination/Pagination";
import Loader from "../../component/common/Loader";
import { SelfAssessmentPageData, ViewAllAssessmentPageData } from "../../utils/experienceConstants";
const AllAssessment = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [assessmentData, setAssessmentData] = useState([]);
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [assessmentId, setAssessmentId] = useState(null);
  const [total, setTotal] = useState();
  const itemsPerPage = 12;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  const [assessmentType, setAssessmentType] = useState(6);
  const [isOpenNew, setIsOpenNew] = useState(false);
  const [selectedOptionNew, setSelectedOptionNew] = useState("New Assessment");
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const popupOption = ["attatchment", "percentage"];

  const assessmentStatusColor = {
    0: "bg-[#1F1F1F]",
    1: "bg-[#67A14A]",
    2: "bg-[#F05289]",
    3: "bg-[#21BDAD]",
  };

  const getTypeColor = (index) => {
    return assessmentStatusColor[Math.floor(index / 3)];
  };

  const totalPages = Math.ceil(total / itemsPerPage);

  // Get All Assessment Data from API
  const getAssessmentData = () => {
    setLoader(true);
    Api.getAssessment(currentPage, searchTerm, assessmentType, itemsPerPage)
      .then((response) => {
        if (response?.data?.meta?.code === 1) {
          setAssessmentData(response?.data?.data);
          setCurrentPage(response?.data?.meta?.page || 1);
          setTotal(response?.data?.meta?.total);
        } else {
          setAssessmentData([]);
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDeleteAssessment = (assessmentId) => {
    setLoader(true);
    Api.deleteAssessment(assessmentId)
      .then((response) => {
        if (response?.data?.meta?.code === 1) {
          getAssessmentData();
          setAssessmentId(null);
          setIsShowDropdown(null);
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (assessmentType !== null) {
      getAssessmentData();
    }
  }, [assessmentType]);

  // const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  //   const getVisiblePageNumbers = () => {
  //     if (totalPages <= 5) {
  //       return Array.from({ length: totalPages }, (_, i) => i + 1);
  //     }

  //     if (currentPage <= 3) {
  //       return [1, 2, 3, 4, 5, '...'];
  //     }

  //     if (currentPage >= totalPages - 2) {
  //       return ['...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  //     }

  //     return [
  //       '...',
  //       currentPage - 2,
  //       currentPage - 1,
  //       currentPage,
  //       currentPage + 1,
  //       currentPage + 2,
  //       '...'
  //     ];
  //   };

  //   const visiblePageNumbers = getVisiblePageNumbers();

  //   return (
  //     <div className="flex sm:justify-between justify-center w-full items-center m-4 gap-4">
  //       <div className="hidden sm:flex">
  //         <button
  //           onClick={() => onPageChange(currentPage - 1)}
  //           disabled={currentPage === 1}
  //           className="w-[200px] h-[45px] border border-black rounded-full text-black bg-white hover:bg-gray-100 disabled:opacity-50 transition-all"
  //         >
  //           Previous page
  //         </button>
  //       </div>
  //       <div className="flex min-w-[254px] w-[25%] gap-4 justify-center">
  //         {visiblePageNumbers.map((number, index) => (
  //           <button
  //             key={index}
  //             onClick={() => typeof number === 'number' && onPageChange(number)}
  //             className={`px-[11.5px] py-2 rounded-full ${
  //               currentPage === number
  //                 ? 'bg-[#1F1F1F]/20 text-[#1F1F1F] scale-125 text-[20px] transition-all'
  //                 : 'text-gray-500 text-[20px] hover:bg-gray-200 hover:text-black transition-all scale-100'
  //             }`}
  //             disabled={typeof number !== 'number'}
  //           >
  //             {typeof number === 'number' ? (number < 10 ? `0${number}` : number) : '...'}
  //           </button>
  //         ))}
  //       </div>
  //       <div className="hidden sm:flex">
  //         <button
  //           onClick={() => onPageChange(currentPage + 1)}
  //           disabled={currentPage === totalPages}
  //           className="w-[200px] h-[45px] bg-[#1F1F1F] text-white rounded-full hover:bg-[#1F1F1F] disabled:opacity-50 transition-all"
  //         >
  //           Next Page
  //         </button>
  //       </div>
  //     </div>
  //   );
  // };
  const onDropDownSelect = (index, id, selectIndex) => {
    if (id === null) {
      errorToast("Assessment ID not found");
      return;
    }
    switch (selectIndex) {
      case 0:
        navigate(`/self-assessment/manage/create?view=4&id=${id}`);
        break;
      case 1:
        handleDeleteAssessment(id);
        break;
      case 2:
        console.log(assessmentData[index]);
        if (assessmentData[index].type === 1 ?? 3) {
          navigate(
            `/self-assessment/manage/create?view=0&id=${id}&type=0`
          );
          break;
        }
        if (assessmentData[index].type === 0 ?? 3) {
          navigate(
            `/self-assessment/manage/create?view=0&id=${id}&type=1`
          );
          break;
        }
        errorToast("Invalid Assessment Type");
        break;

      default:
        errorToast("Invalid action");
        break;
    }
  };

  const TemplateCard = ({ index, assessment }) => (
    <div className="card-content flex items-center border border-shoorah-borderGray rounded-xl p-4 gap-6 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder relative">
      <div className="img-box rounded-xl overflow-hidden min-w-[141px] w-[141px] h-[141px] bg-red-300">
        <img
          src={assessment?.coverImage ? assessment?.coverImage : shoorahLogo}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = shoorahLogo;
          }}
          alt="Template"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="content-box w-full">
        <button
          className="absolute top-2 right-4"
          onClick={() => [
            setIsShowDropdown(!isShowDropdown),
            setAssessmentId(assessment?.id),
          ]}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="dark:invert"
          >
            <path
              d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
              stroke="#0B1D2E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
              stroke="#0B1D2E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
              stroke="#0B1D2E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="dropdown-menu relative">
          {isShowDropdown && assessmentId === assessment?.id && (
            <ul class="w-auto h-fit overflow-y-auto rounded-xl  z-10 bg-white border-[1.5px] border-shoorah-borderGray ms-auto absolute top-full right-0 dark:text-shoorah-darkBg dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
              {(assessmentType === 0 || assessmentType === 1) && <></>}

              <li
                class="pl-4 pr-6 py-2 hover:bg-shoorah-borderGray hover:dark:text-shoorah-darkBgColor cursor-pointer text-left capitalize"
                onClick={() => {
                  onDropDownSelect(index, assessment?.id, 2);
                  setIsShowDropdown(false);
                }}
              >
                {ViewAllAssessmentPageData.templateCards.actionDropdownItems.ItemOne}
              </li>
              {assessmentType != 1 && (
                <>
                  <li
                    class="pl-4 pr-6 py-2 hover:bg-shoorah-borderGray hover:dark:text-shoorah-darkBgColor cursor-pointer text-left capitalize"
                    onClick={() => {
                      onDropDownSelect(index, assessment?.id, 0);
                      setIsShowDropdown(false);
                    }}
                  >
                    {ViewAllAssessmentPageData.templateCards.actionDropdownItems.ItemTwo}
                  </li>
                </>
              )}

              <li
                class="pl-4 pr-6 py-2 hover:bg-shoorah-borderGray hover:dark:text-shoorah-darkBgColor cursor-pointer text-left capitalize"
                onClick={() => {
                  onDropDownSelect(index, assessment?.id, 1);
                  setIsShowDropdown(false);
                }}
              >
                {ViewAllAssessmentPageData.templateCards.actionDropdownItems.ItemThree}
              </li>
            </ul>
          )}
        </div>
        <p className="text-[16px] text-[#000000] font-bold leading-snug whitespace-normal break-all line-clamp-2 dark:text-shoorah-darkBg">
          {assessment?.title}
        </p>
        <p className="text-[13px] text-[#000000] mt-[10px] dark:text-shoorah-darkBg">
          {ViewAllAssessmentPageData.templateCards.usedByString.textBeforeUserCount} {assessment?.usedBy || 0} {ViewAllAssessmentPageData.templateCards.usedByString.textAfterUserCount}
        </p>
        <button
          className={`text-white font-thin w-[108px] text-[14px] mt-[14px] px-2 py-[6px] rounded-[10px] self-start ${getTypeColor(
            index
          )}`}
        >
          {assessment?.type === 1 ? ViewAllAssessmentPageData.templateCards.cardActionButtonOne : ViewAllAssessmentPageData.templateCards.cardActionButtonTwo}
        </button>
      </div>
    </div>
  );
  const toggleDropdownNew = () => {
    setIsOpenNew((prev) => !prev);
  };
  const handleOptionClickNew = (option) => {
    setSelectedOptionNew(option);
    setIsOpenNew(false);
  };
  const toggleFilter = () => {
    setIsFilterOpen((prev) => !prev);
  };
  const handleFilterOption = (option) => {
    setAssessmentType(option);
    setIsFilterOpen(false);
  };

  const togglePopUp = () => {
    setIsPopupOpen((prev) => !prev);
  };

  const handlePopupOptionClick = (option) => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    getAssessmentData();
  }, [currentPage, searchTerm]);

  return (
    <div className="mx-auto max-w-[1640px]">
      <div className=" font-medium">
        {loader && <Loader />}
        <Topbar title={ViewAllAssessmentPageData.topbarTitleText} />
        <div className="flex flex-wrap sm:justify-between gap-4 justify-center lg:mt-8 sm:mb-4">
          <div className="flex flex-col sm:flex-row w-full sm:w-auto">
            <div className="w-full sm:w-auto">
              <SearchInput
                id="searchKey"
                name="searchKey"
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder={ViewAllAssessmentPageData.searchPlaceholder}
                className="w-full max-w-md border rounded-md p-2" // Adjust the max-w-md class as needed
              />
            </div>
          </div>
          <div className="flex flex-wrap sm:justify-end w-full sm:w-auto">
            <div className="relative inline-block text-left mb-4 sm:mb-0 mr-2">
              <button
                type="button"
                onClick={toggleFilter}
                className="inline-flex justify-between items-center w-full px-3 py-[7px] sm:text-sm text-[12px] font-medium text-gray-700 border dark:border-text-shoorah-darkBg border-[#0B1D2E] sm:rounded-[100px] rounded-[80px] dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
              >
                {assessmentType === 0
                  ? ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeZeroBtnText
                  : assessmentType === 1
                    ? ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeOneBtnText
                    : assessmentType === 2
                      ? ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeTwoBtnText
                      : assessmentType === 3
                        ? ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeThreeBtnText
                        : assessmentType === 4
                          ? ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeFourBtnText
                          : assessmentType === 5
                            ? ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeFiveBtnText
                            : assessmentType === 6
                              ? ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeSixBtnText
                              : ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.defaultBtnText}
                <svg
                  className={`transform transition-transform ml-0 sm:ml-3 dark:invert ${isFilterOpen ? "rotate-180" : "rotate-0"
                    }`}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.28 9.9668L12.9333 14.3135C12.42 14.8268 11.58 14.8268 11.0666 14.3135L6.71997 9.9668"
                    stroke="#0B1D2E"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              {isFilterOpen && (
                <div className="absolute left-[-12px] z-10 mt-1 w-[160px] bg-white divide-y divide-gray-100 rounded-md ring-1 ring-[#E7EAE8] ring-opacity-1 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder dark:ring-opacity-0">
                  <ul className="py-1 text-sm text-gray-700 dark:text-shoorah-darkBg">
                    <li>
                      <button
                        onClick={() => handleFilterOption(0)}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                      >
                        {ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeZeroBtnText}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleFilterOption(1)}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                      >
                        {ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeOneBtnText}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleFilterOption(2)}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                      >
                        {ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeTwoBtnText}
                      </button>
                    </li>
                    {isSubAdmin() && (
                      <li>
                        <button
                          onClick={() => handleFilterOption(3)}
                          className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                        >
                          {ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeThreeBtnText}
                        </button>
                      </li>
                    )}

                    <li>
                      <button
                        onClick={() => handleFilterOption(4)}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                      >
                        {ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeFourBtnText}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleFilterOption(5)}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                      >
                        {ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeFiveBtnText}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleFilterOption(6)}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                      >
                        {ViewAllAssessmentPageData.actionBtnTextAsPerAssessmentType.typeSixBtnText}
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div className="relative flex flex-row justify-center items-center lg:w-[200px] sm:w-[160px] sm:px-0 px-5 h-[40px] bg-[#1F1F1F] sm:text-[16px] text-[12px] sm:rounded-[100px] rounded-[80px] text-white">
              <button
                className="flex flex-row items-center"
                type="button"
                onClick={togglePopUp}
              >
                {selectedOptionNew}
              </button>
              {/* {isOpenNew && (
                <div className="absolute top-[40px] md:top-[40px] lg:top-[40px] z-10 mt-1 w-[199px] md:lg:w-[220px] bg-white divide-y divide-gray-100 rounded-md ring-1 ring-[#E7EAE8] ring-opacity-1">
                  <ul className="py-1 text-sm text-gray-700">
                    <li>
                      <Link
                        to={getPathForSurvey(`/self-assessment/manage/create?type=1`)}
                        onClick={() => handleOptionClickNew('attatchment')}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 truncate"
                      >
                        Attachment Assessment
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={getPathForSurvey(`/self-assessment/manage/create?type=0`)}
                        onClick={() => handleOptionClickNew('percentage')}
                        className="block px-4 py-2 w-full text-left truncate hover:bg-gray-100"
                      >
                        Percentage Assessment
                      </Link>
                    </li>
                  </ul>
                </div>
              )} */}
            </div>
          </div>
        </div>
        <AddSurveyPopup
          open={isPopupOpen}
          setOpen={togglePopUp}
          popupOption={popupOption}
          path1={getPathForSurvey(
            "/self-assessment/manage/create?type=1"
          )}
          path2={getPathForSurvey(
            "/self-assessment/manage/create?type=0"
          )}
          handlePopuopOptionClick={(option) => handlePopupOptionClick(option)}
          popupHeading={SelfAssessmentPageData.createAssessmentModal.title}
          firstTitle={SelfAssessmentPageData.createAssessmentModal.selectMenuOne.label}
          firstSubtitle={SelfAssessmentPageData.createAssessmentModal.selectMenuOne.subTitle}
          secondTitle={SelfAssessmentPageData.createAssessmentModal.selectMenuTwo.label}
          secondSubTitle={SelfAssessmentPageData.createAssessmentModal.selectMenuTwo.subTitle}
        />

        {/* Cards list */}
        <div className="flex flex-col h-fit bg-[#FFFFFF] border-[1.5px] border-shoorah-borderGray rounded-[16px] mt-2 mb-[32px] dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
          <div className=" flex flex-row justify-between p-6 items-center mb-[7px]">
            <p className="text-[24px] text-[#0B1D2E] dark:text-shoorah-darkBg">
              {ViewAllAssessmentPageData.allAssessmentHeadingText}
            </p>
          </div>
          <div className="flex flex-col">
            {assessmentData === null || assessmentData?.length === 0 ? (
              <div className="grid grid-cols-1 gap-5 mx-6 mb-8">
                <h1 className="text-center text-[20px] text-shoorah-customGray">
                  {ViewAllAssessmentPageData.emptyDataText}
                </h1>
              </div>
            ) : (
              <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-2 gap-y-6 mx-6 mb-[26px]">
                {assessmentData?.map((assessment, index) => (
                  <TemplateCard
                    key={index}
                    index={index}
                    assessment={assessment}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
        {assessmentData?.length > 0 && (
          // <div className="bottom-[-100px] mt-[20px] sticky w-[100%] h-[91px] rounded-[16px] align-middle overflow-hidden flex justify-center mx-0 border border-shoorah-borderGray bg-[#FFFFFF]">
          <Pagination
            currentPage={currentPage}
            totalCount={total}
            pageSize={itemsPerPage}
            onPageChange={setCurrentPage}
          />
          // </div>
        )}
      </div>
    </div>
  );
};

export default AllAssessment;
